/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-tabs {
  --indicator-background: var(--nve-sys-accent-secondary-background);
  --indicator-height: var(--nve-ref-border-width-xl);
  --indicator-border-radius: var(--nve-ref-border-radius-sm);

  &::after {
    background: var(--indicator-background);
    height: var(--indicator-height);
    border-radius: var(--indicator-border-radius);
    position: fixed;
    display: block;
    content: '';
    width: anchor-size(width);
    transition: left var(--nve-ref-animation-duration-150) var(--nve-ref-animation-easing-100);
    position-anchor: --selected;
    top: calc(anchor(bottom) - var(--indicator-height));
    left: anchor(left);
    z-index: -1;
  }

  &[borderless]::after {
    display: none !important;
  }
}

nve-tabs[vertical] {
  &::after {
    width: var(--indicator-height);
    height: anchor-size(height);
    transition: top var(--nve-ref-animation-duration-150) var(--nve-ref-animation-easing-100);
    top: anchor(top);
  }
}

nve-tabs-item {
  &[selected] {
    anchor-name: --selected;
  }
}
